.route {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1em;
  justify-content: stretch;
}

.dispatchItemRow {
  display: grid;
  grid-template-columns: 50fr 20fr 20fr min-content;
  align-items: flex-start;
  column-gap: 2em;
  margin-bottom: 0.5em;
}

.buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
}

.tabletFormSubmitSection button[type="submit"] {
  /* Override the default margin of the purecss button on mobile */
  margin: 0 !important;
}

.tabletFormSubmitButtons {
  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
  align-items: center;
  justify-items: stretch;
}

.tabletFormSubmitButtons > :nth-child(1) {
  grid-column: 1 / -1;
}

/** Tablet Form */

.modalPanelTablet {
  --margin-y: max(15px, calc(env(safe-area-inset-bottom) + 5px));
  position: relative;
  display: flex;
  padding: 15px;
  padding-top: 0.35em;
  background-color: var(--bg-color);
  width: 100%;
  border: var(--border);
  border-radius: 6px;
  /* Fallback for browsers that don't support dvh properly */
  height: calc(100vh - var(--margin-y) * 2);
  margin-top: var(--margin-y);
}

@supports (height: 100dvh) {
  .modalPanelTablet {
    height: calc(100dvh - var(--margin-y) * 2);
  }
}

.formTablet {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.formTablet textarea[name="comment"] {
  margin-bottom: 0;
}

.formTabletContent {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  gap: 1em;
  height: 100%;
  overflow: hidden;
}

.formTabletContent > [data-slot="products"] {
  display: flex;
  gap: 1em;
  flex-direction: column;
  grid-row: 2;
  overflow: hidden;
}

.formTabletContent > [data-slot="route"] {
  grid-row: 1;
}

.tabletFormSubmitSection {
  align-self: end;
  grid-row: 3;
  display: flex;
  flex-direction: column;
  gap: 1em;
}

@media (min-width: 480px) {
  .tabletFormSubmitButtons {
    grid-template-rows: auto;
    grid-template-columns: auto min-content min-content;
    align-items: center;
    justify-items: start;
  }

  .tabletFormSubmitButtons > :first-child {
    grid-column: auto;
  }
}

@media (min-width: 1024px) and (orientation: landscape) {
  .formTabletContent {
    grid-template-columns: 2fr 200px;
    grid-template-rows: 1fr 1fr;
  }

  .formTabletContent > [data-slot="products"] {
    grid-row-start: 1;
    grid-row-end: 3;
    grid-column: 1;
    height: 100%;
  }

  .formTabletContent > [data-slot="route"] {
    grid-row: 1;
    grid-column: 2;
  }

  .tabletFormSubmitSection {
    display: flex;
    flex-direction: column;
    gap: 1em;
    align-self: end;
    grid-row: 2;
    grid-column: 2;
  }

  .tabletFormSubmitButtons {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .formTabletContent .route {
    display: flex;
    flex-direction: column;
    gap: 1em;
  }
}

.searchInput {
  width: 100%;
  /* Override the default margin of the purecss input on mobile */
  margin-bottom: 0 !important;
}

.categoryFilter {
  grid-column: 1 / -1;
  overflow-x: auto;
  overscroll-behavior-x: contain;
}

input:placeholder-shown + .resetSearchButton {
  display: none;
}

input:focus + .resetSearchButton {
  border-color: var(--highlight-blue);
}

.resetSearchButton {
  appearance: none;
  touch-action: manipulation;
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: color-mix(in srgb, var(--font-color) 50%, transparent);
  border-bottom: var(--border);
  text-align: center;
  padding: 5px 10px;
  line-height: 1;
  transition: border-color 0.2s;
}

.products {
  flex: 1;
  display: grid;
  gap: 1em;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  /* Add a small padding to avoid the borders being cut off */
  padding: 1px 0;
}

.categoryGroup {
  display: flex;
  flex-direction: column;
  gap: 0.75em;
}

.categoryHeadline {
  font-size: 1rem;
  margin: 0;
}

.categoryProducts {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  grid-auto-rows: min-content;
  gap: 1em;
}

.productsHeader {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 1em;
}

.productsHeader > :nth-child(2) {
  justify-self: end;
}

.productTile {
  --tile-background-color: color-mix(
    in srgb,
    var(--category-color, var(--bg-color)) 50%,
    var(--bg-color)
  );
  display: flex;
  flex-direction: column;
  gap: 0.75em;
  padding: 0.5em;
  border: 1px solid var(--category-color, var(--border-light-grey));
  border-radius: 6px;
  border-width: 1px;
  transition: border-color 0.1s ease-in-out;
  background-color: var(--tile-background-color);
}

.productTileWithInput {
  composes: productTile;
  border-color: var(--highlight-blue);
}

.productName {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;
  font-weight: bold;
  gap: 0.5em;
  font-size: 0.875rem;
  line-height: 1.2;
}

.productNameText {
  flex: 1;
}

.clearButtonContainer {
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(
    to right,
    transparent 0%,
    var(--tile-background-color, var(--bg-color)) 50%
  );
  width: 60px;
  display: flex;
  justify-content: end;
}

.clearButtonContainer button {
  line-height: 1;
  padding: 8px 10px;
  margin: -5px;
}

.inputRow {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  justify-items: center;
  width: 100%;
  gap: 0.5em;
}

.inputRow label {
  user-select: none;
  /* Override the default margin of the purecss label */
  margin: 0 !important;
}

.inputRow label > input {
  font-size: 1rem;
}

.stepperButton {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  background-color: color-mix(
    in srgb,
    var(--category-color, var(--bg-light-grey)) 80%,
    var(--bg-color)
  );
  color: color-mix(in srgb, var(--category-color, var(--font-color)) 40%, black);
  border-radius: 22px;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
  line-height: 0;
  transition: background-color 0.1s ease-in-out;
}

.stepperButton::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  width: 48px;
  height: 48px;
  /* Make it clickable */
  pointer-events: auto;
  /* Invisible */
  background: transparent;
  z-index: -1;
}

.stepperButton:disabled {
  cursor: default;
  opacity: 0.66;
}

.stepperButtonTouched {
  composes: stepperButton;
  background-color: color-mix(
    in srgb,
    var(--category-color, var(--font-color)) 90%,
    black
  );
}
